import React, { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { BackgroundWaves, ChapterLogo } from "~/common/assets";
import { LOGO_POSITION } from "~/common/constants";

interface ErrorScreenLayoutProps extends PropsWithChildren {
  logoPosition?: keyof typeof LOGO_POSITION;
  backgroundUrl?: string;
}

const ErrorLayout = ({
  children,
  backgroundUrl,
  logoPosition = LOGO_POSITION.bottom,
}: ErrorScreenLayoutProps) => {
  return (
    <div
      className="flex h-screen-calculated items-center justify-center bg-cover bg-center text-gray-70"
      style={{ backgroundImage: `url(${backgroundUrl ?? BackgroundWaves})` }}
    >
      {children}
      <div
        className={twMerge(
          "absolute flex w-full items-center justify-center p-12",
          logoPosition === LOGO_POSITION.top ? "top-0" : "bottom-0",
        )}
      >
        <img src={ChapterLogo} alt="Chapter Logo" />
      </div>
    </div>
  );
};

export default ErrorLayout;
